import React from 'react';
import { getBezierPath, EdgeLabelRenderer } from '@xyflow/react';

const FlowEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  sourceHandleId,
  style = {},
  markerEnd,
}) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const isYesPath = sourceHandleId === 'yes';
  const isNoPath = sourceHandleId === 'no';
  const hasLabel = isYesPath || isNoPath;

  const edgeColor = isYesPath ? '#22c55e' : isNoPath ? '#ef4444' : '#94a3b8';

  return (
    <>
      <path
        id={id}
        style={{ ...style, stroke: edgeColor, strokeWidth: 2 }}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
      />
      {hasLabel && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
              pointerEvents: 'all',
            }}
            className="nodrag nopan"
          >
            <span className={`text-[10px] font-medium px-1.5 py-0.5 rounded-full ${
              isYesPath ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
            }`}>
              {isYesPath ? 'Yes' : 'No'}
            </span>
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
};

export default FlowEdge;
